<template>
  <div>
    <div class="card">
      <!-- <div class="title">
        销假
      </div> -->
      <div style="padding:0 1rem">
        <van-field
          v-model="form.time"
          label="销假时间"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          @click="$refs.starttime.showTimePopup = true"
        />
        <van-field
          v-model="form.remark"
          rows="2"
          autosize
          label="销假原因"
          type="textarea"
          maxlength="50"
          placeholder="请输入原因"
          show-word-limit
        />
      </div>
    </div>
    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      :isFilter="false"
      @time="handleTimeStartConfirm"
      :minDate="startMinTime"
      :maxDate="endMaxTime"
      :currentDate="new Date()"
    />
  </div>
</template>

<script>
import moment from 'moment'
import SelectTime from '@/components/subScribePopup/selectTime'

export default {
  props: {
    status: {},
    sTime: {},
    eTime: {},
  },
  data() {
    return {
      form: {
        time: '',
        remark: '',
      },
    }
  },
  components: {
    SelectTime,
  },
  computed: {
    startMinTime() {
      return new Date(moment(this.sTime))
    },
    // endCurTime() {
    //   return new Date(moment(this.endMinDate).add(1, 'h'))
    // },
    endMaxTime() {
      return new Date(moment(this.eTime))
    },
  },
  methods: {
    handleTimeStartConfirm(value) {
      this.$set(this.form, 'time', value)
      this.$refs.starttime.showTimePopup = false
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #fff;
  margin: 1rem;
  border-radius: 0.75rem;
}
</style>
